import { useState, useEffect, useRef, useCallback } from "react";
import { getReviewsUnreadCount } from "../lib/api";

// Polls the employee's unacknowledged published-review count. Mirrors the
// admin support-badge poll. Returns { count, refresh }.
export function useReviewsUnread(enabled = true, intervalMs = 60_000) {
  const [count, setCount] = useState(0);
  const alive = useRef(true);

  const refresh = useCallback(() => {
    getReviewsUnreadCount()
      .then((d) => {
        if (alive.current) setCount(d?.count || 0);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }
    alive.current = true;
    refresh();
    const id = setInterval(refresh, intervalMs);
    return () => {
      alive.current = false;
      clearInterval(id);
    };
  }, [enabled, intervalMs, refresh]);

  return { count, refresh };
}
